export default __webpack_public_path__ + "static/media/profile.15d0112f.png";